// Utils
import getAppUrl from '../../../../../../utils/getAppUrl';

export const getPublicLink = (currentBoardId) => `${getAppUrl()}/${currentBoardId}`;
